import { CoreModule } from '@abp/ng.core';
import * as i0 from '@angular/core';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AccountSettingsComponent, AccountSettingsModule } from '@volo/abp.ng.account/admin';
import { SettingTabsService } from '@abp/ng.setting-management/config';

const ACCOUNT_SETTING_TAB_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        useFactory: configureSettingTabs,
        deps: [SettingTabsService],
        multi: true,
    },
];
function configureSettingTabs(settingtabs) {
    return () => {
        settingtabs.add([
            {
                name: "AbpAccount::Menu:Account" /* eAccountSettingTabNames.Account */,
                order: 103,
                requiredPolicy: 'AbpAccount.SettingManagement',
                component: AccountSettingsComponent,
            },
        ]);
    };
}

class AccountAdminConfigModule {
    static forRoot() {
        return {
            ngModule: AccountAdminConfigModule,
            providers: [ACCOUNT_SETTING_TAB_PROVIDERS],
        };
    }
}
AccountAdminConfigModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: AccountAdminConfigModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AccountAdminConfigModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.2", ngImport: i0, type: AccountAdminConfigModule, imports: [CoreModule, AccountSettingsModule], exports: [AccountSettingsModule] });
AccountAdminConfigModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: AccountAdminConfigModule, imports: [CoreModule, AccountSettingsModule, AccountSettingsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: AccountAdminConfigModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CoreModule, AccountSettingsModule],
                    exports: [AccountSettingsModule],
                    declarations: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ACCOUNT_SETTING_TAB_PROVIDERS, AccountAdminConfigModule, configureSettingTabs };
